import React, { Component } from "react";
import {
  Grid,
  Row,
  Col
  // FormGroup,
  //ControlLabel as FormLabel,
  //FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
//import { UserCard } from "components/UserCard/UserCard.jsx";
import Button from "components/CustomButton/CustomButton.jsx";

//import avatar from "assets/img/faces/face-3.jpg";

class UserProfile extends Component {
  render() {
    console.log(this.props);
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Edit Profile"
                content={
                  <form>
                    <FormInputs
                      ncols={["col-md-4", "col-md-3"]}
                      proprieties={[
                        {
                          label: "Login",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Login",
                          defaultValue: this.props.userData.name
                        },
                        {
                          label: "Adres Email",
                          type: "email",
                          bsClass: "form-control",
                          placeholder: this.props.userData.email
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "Imię",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Imię",
                          defaultValue: this.props.userData.name
                        },
                        {
                          label: "Nazwisko",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Nazwisko",
                          defaultValue: this.props.userData.surname
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          label: "Adres",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Adres",
                          defaultValue: ""
                        }
                      ]}
                    />
                    <FormInputs
                      ncols={["col-md-4", "col-md-4", "col-md-4"]}
                      proprieties={[
                        {
                          label: "Miasto",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Miasto",
                          defaultValue: this.props.userData.city
                        },
                        {
                          label: "Kraj",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Kraj",
                          defaultValue: "Polska"
                        },
                        {
                          label: "Poczta",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: this.props.userData.post_code
                        }
                      ]}
                    />

                    <Button
                      bsStyle="info disabled"
                      pullRight
                      fill
                      type="submit"
                    >
                      Update Profile
                    </Button>
                    <div className="clearfix" />
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
        >
      </div>
    );
  }
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/views/UserProfile/UserProfile.jsx